import type { DeepPartial } from '@luna/utils-ts';

import type { PaymentOrders } from './PaymentsOrders';

export const AT: DeepPartial<PaymentOrders> = {
    legacyPaymentsFetch: {
        enabled: true,
    },
    datacarrier: {
        asyncUpload: {
            enabled: false,
        },
    },
};
